"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSeriesReferenceSchema = void 0;
exports.EventSeriesReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/content/event-series.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "EventSeriesReference",
    "description": "An event series groups multiple event profiles, such as a tournament or championship series. It's possible to either group event profiles directly or related event seasons (e.g. competition years).",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:master:event-series"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQtc2VyaWVzLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tb2R1bGVzL3JlZmVyZW5jZS9jb250ZW50L2V2ZW50LXNlcmllcy5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSwwQkFBMEIsR0FBRztJQUN4QyxLQUFLLEVBQUUsNEVBQTRFO0lBQ25GLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHNCQUFzQjtJQUMvQixhQUFhLEVBQUUsdU1BQXVNO0lBQ3ROLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixJQUFJO0tBQ0w7SUFDRCxZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUU7Z0JBQ04seUJBQXlCO2FBQzFCO1lBQ0QsTUFBTSxFQUFFLFFBQVE7U0FDakI7UUFDRCxJQUFJLEVBQUU7WUFDSixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsNkVBQTZFO1NBQ3pGO0tBQ0Y7Q0FDRixDQUFBIn0=